import { render, staticRenderFns } from "./DetailsItemnumber.vue?vue&type=template&id=2e8e2e9c&"
import script from "./DetailsItemnumber.vue?vue&type=script&lang=ts&"
export * from "./DetailsItemnumber.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports